import { useEffect, useState } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { auth } from '@/lib/firebase';

export type AuthState =
  | { state: 'loading' }
  | { state: 'signedOut' }
  | { state: 'signedIn'; user: User };

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ state: 'loading' });
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) setState({ state: 'signedIn', user });
      else setState({ state: 'signedOut' });
    });
    return unsub;
  }, []);
  return state;
}
